import { RecNestedEntity, Recommendation } from '@core/models/recommendation.models';

export interface CurrentRecommendationState {
  data: Recommendation<RecNestedEntity>;
  isLoading: boolean;
  isLoaded: boolean;
}
